module.exports = __webpack_public_path__ + "assets/img/driver-active-btn-8f752dca.png";